'use client'

import {useParams, useSearchParams} from 'next/navigation'

import {useNavigation} from './useNavigation'

/**
 * `useNavigation()` plus the two members that need the query string, `query` and `asPath`.
 *
 * Prefer `useNavigation()` unless you actually read one of those two. This hook calls
 * `useSearchParams()`, which re-renders on every query-string change and opts the component out
 * of static rendering unless it sits under a `<Suspense>` boundary.
 */
export function useRouter() {
  const searchParams = useSearchParams()
  const params = useParams() || {}

  const navigation = useNavigation()

  // the query string and the dynamic route params in one record, as the Pages Router had it
  const query = Object.fromEntries(searchParams ? searchParams.entries() : [])
  for (const [key, value] of Object.entries(params)) {
    if (key === 'locale') {
      continue
    }
    query[key] = value as string
  }

  return {
    ...navigation,
    query,
    asPath:
      searchParams && searchParams.size > 0
        ? `${navigation.pathname}?${searchParams.toString()}`
        : navigation.pathname,
  }
}
